// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-headersegment-issues-module__xAxisPadding--g2SMO {
  padding-left: 10px;
  padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/js/headersegment/issues.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".xAxisPadding {\n  padding-left: 10px;\n  padding-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xAxisPadding": `src-js-headersegment-issues-module__xAxisPadding--g2SMO`
};
export default ___CSS_LOADER_EXPORT___;
